import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Layout from "./layout";
import SearchIcon from "@mui/icons-material/Search";
import TableSortLabel from "@mui/material/TableSortLabel";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { jsPDF } from "jspdf";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, DialogContentText } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import "jspdf-autotable";
import "../App.css";
import issueProductIcon from "../images/issueProduct.png";
import editProductIcon from "../images/editProduct.png";
import returnProductIcon from "../images/returnProduct.png";
import Tooltip from "@mui/material/Tooltip";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useAcademicYear } from "./AcademicYearContext";
import EventProductIssue from "./EventProductIssue";
import EventProductEdit from "./EventProductEdit";
import EventReturnProduct from "./EventProductReturn";
import InfoIcon from "@mui/icons-material/Info";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function IssueProduct() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("event_issue_product_id");
  const [roleName, setRoleName] = useState("");
  const [data, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [product, setProduct] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedIssueProductId, setSelectedIssueProductId] = useState(null);
  const [openIssueComponent, setOpenIssueComponent] = useState(false);
  const [staffId1, setStaffId1] = useState("");
  const [staffName, setStaffName] = useState("");

  const [dialogType, setDialogType] = useState(""); // Add this line
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [refundedStatusId, setRefundedStatusId] = useState(null);
  const [saleStatus, setSaleStatus] = useState([]);
  const [userId, setUserId] = useState();
  const [totalStockQuantity, setTotalStockQuantity] = useState([]); // Initialize appropriately
  const [totalQuantity, setTotalQuantity] = useState([]); // Initialize appropriately
  const [totalProduct, setTotalProduct] = useState([]); // Initialize as needed
  const [deleteData, setDeleteData] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [statusId, setStatusId] = useState(undefined);
  const [openComponentCreateSale, setOpenComponentCreateSale] = useState(false);
  const [openComponentRefundSale, setOpenComponentRefundSale] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessageForReturn, setDialogMessageForReturn] = useState("");
  const [needsReturn, setNeedsReturn] = useState(false);
  const [OpenReturnComponent, setOpenReturnComponent] = useState(false);
  const [SelectedEventissueProductId, setSelectedEventissueProductId] =
    useState(null);
  const [SelectedEventName, setSelectedEventName] = useState("");
  const [SelectedEventStatusId, setSelectedEventStatusId] = useState(null);
  const [SelectedEventId, setSelectedEventId] = useState(null);

  const [SelectedEventCategory, setSelectedEventCategory] = useState("");
  const [EventId, setEventId] = useState();
  const [openEditComponent, setopenEditComponent] = useState(false);
  const [openReturnProductComponent, setopenReturnProductComponent] =
    useState(false);
  const [EventDescription, setEventDescription] = useState("");
  const [EditComponentName, setEditComponentName] = useState("");

  const instituteId = localStorage.getItem("instituteId");
  const handleClick = (row) => {
    setProduct([]);
    getProduct(row.event_issue_product_id);
    setSelectedEventCategory(row.event_category_name);
    setopenReturnProductComponent(true);
    if (row.issue_product_status === 2 || row.issue_product_status === 3) {
      handleOpenComponentRefundSale(row); // Open refund sale component
    } else if (row.issue_product_status === 1) {
      setDialogMessageForReturn(
        "Cannot return. Your products have not been issued yet.",
      );
      setOpenDialog(true);
    } else if (row.issue_product_status === 4) {
      setDialogMessageForReturn("Your products are already returned.");
      setOpenDialog(true);
    }
  };

  const navigate = useNavigate();
  const { academicYearId } = useAcademicYear();

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Fetched data:", data);

      const issuedStatus =
        data.find((item) => item.description === "Issued")
          ?.issue_product_status_id || null;
      const refundedStatus =
        data.find((item) => item.description === "Returned")
          ?.issue_product_status_id || null;

      console.log("Issued Sale Status ID:", issuedStatus);

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setIssuedStatusId(issuedStatus);
      setRefundedStatusId(refundedStatus);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  useEffect(() => {
    console.log("Current deleteData:", deleteData);
  }, [deleteData]);

  const handleOpenComponentCreateSale = () => {
    setOpenIssueComponent(true);
    getSales();
  };

  const handleOpenComponentRefundSale = (row) => {
    setStaffId1(row.event_issue_product_id || "Unknown ID");
    setProduct([]);
    getProduct(row.event_issue_product_id);
    console.log("fetched rpoduct for refumd sale", product);
    setSelectedIssueProductId(row.event_issue_product_id);
    setSelectedEventName(row.event_name);
    setSelectedEventCategory(row.event_category_name);
    setOpenComponentRefundSale(true);
  };
  useEffect(() => {
    console.log("SelectedEventCategory received:", SelectedEventCategory);
  }, [SelectedEventCategory]);

  const handleEditOpenComponent = (row) => {
    console.log("Opening edit for row:", row);

    // Set the states with current row data
    setEventId(row.event_id);
    setSelectedEventName(row.event_name);
    setSelectedEventCategory(row.event_category_name);
    setSelectedEventId(row.event_issue_product_id);

    let descriptionToShow = "";

    // 🟢 Created
    if (row.issue_product_status === 1) {
      const currentRow = data.find(
        (d) => d.event_issue_product_id === row.event_issue_product_id,
      );
      descriptionToShow = currentRow?.issue_description || "";
    }

    // 🟡 Issued
    else if (row.issue_product_status === 2) {
      const createdEvent = data.find(
        (entry) =>
          entry.event_name === row.event_name &&
          entry.issue_product_status === 1,
      );
      descriptionToShow = createdEvent?.issue_description || "";
    }

    // 🔵 Partial Return
    else if (row.issue_product_status === 3) {
      // Get the *latest* created event with same name that is NOT issued yet
      const latestCreatedEvent = [...data]
        .filter(
          (entry) =>
            entry.event_name === row.event_name &&
            entry.issue_product_status === 1,
        )
        .sort((a, b) => b.event_issue_product_id - a.event_issue_product_id)[0]; // latest
      descriptionToShow = latestCreatedEvent?.issue_description || "";
    }

    // 🔴 Returned
    else if (row.issue_product_status === 4) {
      // Get the *latest* created event with same name that is NOT issued yet
      const latestCreatedEvent = [...data]
        .filter(
          (entry) =>
            entry.event_name === row.event_name &&
            entry.issue_product_status === 1,
        )
        .sort((a, b) => b.event_issue_product_id - a.event_issue_product_id)[0]; // latest
      descriptionToShow = latestCreatedEvent?.issue_description || "";
    }

    // ✅ Set description finally
    setEventDescription(descriptionToShow);

    // Set matching event details
    const matchingEntry = data.find(
      (entry) =>
        entry.event_name === row.event_name && entry.issue_product_status === 1,
    );

    if (matchingEntry) {
      setSelectedEventissueProductId(matchingEntry.event_issue_product_id);
      setSelectedEventStatusId(matchingEntry.issue_product_status);
    } else {
      setSelectedEventissueProductId(row.event_issue_product_id);
      setSelectedEventStatusId(row.issue_product_status);
    }

    // ✅ Component title
    switch (row.issue_product_status) {
      case 1:
        setEditComponentName("Edit Product");
        break;
      case 2:
        setEditComponentName("Issue Product");
        break;
      case 3:
        setEditComponentName("Partial Return Product");
        break;
      case 4:
        setEditComponentName("Returned Product");
        break;
      default:
        setEditComponentName("Edit Product");
        break;
    }

    setopenEditComponent(true);
  };

  const handleCloseComponent = () => {
    // Close all dialogs
    setopenReturnProductComponent(false);
    setOpenIssueComponent(false);
    setopenEditComponent(false);
    setOpenReturnComponent(false);
    setOpenComponentCreateSale(false);
    setOpenComponentRefundSale(false);

    // Clear all states
    setStaffId1("");
    setStaffName("");
    setEventDescription("");
    setEventId(null);
    setSelectedEventId(null);
    setSelectedEventissueProductId(null);
    setSelectedEventName("");
    setSelectedEventCategory("");

    // Force refresh data from database
    getSales();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const openList = (issueProductId) => {
    setSelectedIssueProductId(issueProductId);
    console.log("issueProductId", issueProductId);
    setProduct([]);
    // Fetch product data first
    getProduct(issueProductId);
    // Then open the dialog
    setOpen(true);
  };

  useEffect(() => {
    if (product) {
      console.log("Updated product state:", product);
    }
  }, [product]);

  const getProduct = async (issueProductId) => {
    console.log("Issue Product ID:", issueProductId);
    setProduct([]);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/events/geteventproductbyid",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            issue_product_id: issueProductId,
          }),
        },
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Product API response:", data);

      if (Array.isArray(data) && data.length > 0) {
        // ✅ Sort products so newest (highest ID) is on top
        const sortedData = [...data].sort(
          (a, b) => b.issue_product_id - a.issue_product_id,
        );

        // ✅ Update state
        setProduct(sortedData);

        // If you want to append instead of replace:
        // setProduct((prev) => [...sortedData, ...prev]);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const handleCheckboxClick = (row) => {
    console.log(
      "hab=ndle click",
      row.issue_product_status,
      row.issue_product_description,
    );

    // Handle different statuses
    // if (row.issue_product_status === 1) {
    setDialogMessage(
      `Are you sure you want to update status for Indent ID ${row.event_issue_product_id} from "Created" to "Issued"?`,
    );
    console.log("dialog masgggg");
    setDialogType("confirmation");
    // }

    // Store the sales ID for use later
    setSelectedIssueProductId(row.event_issue_product_id);

    console.log("Row Sales Id:", row);

    // ✅ Extract product IDs, quantities, and stock correctly
    const productIds = row.sales_details.map((item) => item.product_id);
    const quantities = row.sales_details.map((item) => item.issue_quantity);
    const stocks = row.sales_details.map((item) => item.product_quantity);

    console.log("Product IDs:", productIds);
    console.log("Quantities:", quantities);
    console.log("Stocks:", stocks);

    // ✅ Check for out-of-stock products
    const outOfStockIndex = stocks.findIndex((stock) => stock <= 0);
    if (outOfStockIndex !== -1 && row.issue_product_status === 1) {
      setDialogMessage(
        `Products cannot be issued as stock is not available for Product ID ${productIds[outOfStockIndex]}.`,
      );
      setDialogType("error");
      setDialogOpen(true);
      return;
    }

    // ✅ Store in state
    setTotalProduct(productIds);
    setTotalQuantity(quantities);
    setTotalStockQuantity(stocks);

    // ✅ Open the dialog
    setDialogOpen(true);
  };

  const updateSaleStatus = async (issueProductId) => {
    console.log("issueProductId", issueProductId);
    try {
      // Use the arrays stored in state
      const productIds = totalProduct; // Should be an array
      const quantities = totalQuantity; // Should be an array
      const stocks = totalStockQuantity; // Should be an array

      console.log("productIds", productIds);

      // Prepare the payload for the API request
      const payload = {
        event_issue_product_id: issueProductId,
        updated_by: userId, // Ensure userId is defined in your scope
        updated_timestamp: new Date(),
        issue_product_status: issuedStatusId, // Set the desired sale status ID
        product_id: productIds, // Use the array of product IDs
        stock: stocks, // Use the array of stocks
        quantity: quantities, // Use the array of quantities
        issue_date: new Date(),
        issued_by: userId,
      };

      // Send a single request with the payload
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateSaleStatusEvent`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(payload),
        },
      );

      // If the response status is 401, call signOut
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return; // Stop further execution
      }

      // Check for the response status
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(
          `HTTP error while updating sale status! Status: ${response.status}, Message: ${errorResponse.message}`,
        );
      }

      // Parse the response data
      const result = await response.json();
      return result; // Return result for further processing if needed
    } catch (error) {
      console.error("Error updating sale status:", error);
      return null; // Handle the error as necessary
    }
  };

  const handleDialogConfirm = async () => {
    // Call the updateSaleStatus function with the selected salesId
    const result = await updateSaleStatus(selectedIssueProductId);

    // Check if the update was successful
    if (result) {
      console.log("Sale status updated successfully:", result);
      // You can add additional logic here, such as updating local state or displaying a success message
    } else {
      console.error("Failed to update sale status.");
    }
    getSales();
    setDialogOpen(false); // Close the dialog after confirmation
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
  };

  useEffect(() => {
    getSales();
  }, [academicYearId]);

  useEffect(() => {
    if (academicYearId) {
      getSales();
    }
  }, [academicYearId, statusId, needsReturn, openEditComponent]); // Added openEditComponent

  // 4. Make sure getSales sets data properly:
  const getSales = async () => {
    // setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/events/geteventproductall",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            issue_product_status: statusId ? statusId : null,
            needs_return: needsReturn ? needsReturn : null,
          }),
        },
      );

      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin");
        return;
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      console.log("Fetched sales data:", responseData);

      if (Array.isArray(responseData)) {
        setData(responseData);
      } else {
        console.error("Response is not an array:", responseData);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
      setData([]);
    } finally {
      // setLoading(false); the reason flicker is setLoading so cmmnt it
    }
  };

  //Added Sorting and Pagination
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting comparator
  const comparator = (a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  };

  const filteredData = data.filter((row) => {
    const searchTerm = search.trim().toLowerCase(); // Trim spaces and convert search term to lowercase

    // Check if the search term is empty to include all rows
    if (!searchTerm) return true;

    // Split the search term into words
    const searchWords = searchTerm.split(/\s+/); // Split by spaces

    // Check if all search words are included in any of the fields
    return searchWords.every((word) => {
      const lowerWord = word.toLowerCase();

      return (
        (row.event_issue_product_id?.toString().toLowerCase() || "").includes(
          lowerWord,
        ) ||
        (row.event_name?.toLowerCase() || "").includes(lowerWord) ||
        (row.event_category_name?.toLowerCase() || "").includes(lowerWord) ||
        (row.event_description?.toLowerCase() || "").includes(lowerWord) ||
        (row.issue_date?.toLowerCase() || "").includes(lowerWord) ||
        (row.issued_by?.toLowerCase() || "").includes(lowerWord) ||
        (row.return_date?.toString().toLowerCase() || "").includes(lowerWord) ||
        (row.issue_description?.toString().toLowerCase() || "").includes(
          lowerWord,
        ) ||
        (row.issue_product_description?.toLowerCase() || "").includes(lowerWord)
      );
    });
  });

  // Apply sorting to filtered data
  const sortedRows = [...filteredData].sort(comparator);

  // Apply pagination to the sorted data
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const handleDownload = (row) => {
    // Prevent download if rows are empty or all rows contain no meaningful data
    const isDataEmpty =
      !data ||
      data.length === 0 ||
      data.every(
        (row) =>
          !row.event_issue_product_id &&
          !row.event_name &&
          !row.event_category_name &&
          !row.issue_description &&
          !row.issue_date &&
          !row.issued_by &&
          !row.return_date &&
          !row.description,
      );

    if (isDataEmpty) {
      return;
    }

   const institute = getInstituteConfig(instituteId);

    const doc = new jsPDF();

    // Header background
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);
    }

    // School Name
    const textStartY = 11;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, textStartY, {
      align: "center",
    });

    // Address
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    doc.text(
      institute.address2,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 18,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 22,
        { align: "center" },
      );
    }

    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "EVENT ISSUE PRODUCT REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" },
    ); // Center aligned title
    doc.setFontSize(10);

    //Constants for alignment
    const studentLabelX = 14;

    // Constants for alignment and padding
    const pageWidth = doc.internal.pageSize.getWidth(); // Get the width of the PDF page
    const rightPadding = 14; // Padding from the right edge

    // Add Grade, Fees Slab, Pending Fees, and Section dynamically
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    // --- Add Current Date on the Right Side ---
    // Get the current date
    const today = new Date();
    const currentDate = today.toLocaleDateString("en-GB"); // Format as DD-MM-YYYY

    // Set font for the "Date:" label
    doc.setFont("helvetica", "bold");

    // Get the width of the "Date:" label and the date text
    const dateLabel = "Date: ";
    const dateLabelWidth = doc.getTextWidth(dateLabel);
    const dateWidth = doc.getTextWidth(currentDate);

    // Calculate the X position for the date label (right aligned)
    const dateXPosition = pageWidth - rightPadding - dateWidth - dateLabelWidth; // Position the "Date:" label with padding from the right

    // Add the "Date:" label to the document
    doc.text(dateLabel, dateXPosition, studentDetailsY); // Add the "Date:" label

    // Set font to normal for the actual date
    doc.setFont("helvetica", "normal");
    doc.text(currentDate, dateXPosition + dateLabelWidth, studentDetailsY);

    const statusMap = {
      1: "Created",
      2: "Issued",
      3: "Returned",
      4: "Partial Return",
    };

    // ✅ UPDATED: Added issue_description to tableData
    const tableData = data.map((row) => {
      // Prefer backend's description (already text)
      let statusName = row.issue_product_description;

      // If not available, map from numeric status
      if (!statusName && row.issue_product_status) {
        statusName = statusMap[row.issue_product_status] || "Unknown Status";
      }

      return [
        row.event_issue_product_id,
        row.event_name || "",
        row.event_category_name || "",
        row.issue_description || "", // ✅ Added Description column
        row.issue_date || "",
        row.issued_by || "",
        row.return_date || "",
        statusName,
      ];
    });

    // ✅ UPDATED: Added "Description" header
    // Table settings
    doc.autoTable({
      head: [
        [
          "Indent ID",
          "Event Name",
          "Event Category",
          "Description", // ✅ Added Description header
          "Issued Date",
          "Issued By",
          "Return Date",
          "Status",
        ],
      ],
      body: tableData,
      startY: receiptTextY + 13, // Start table below receipt title
      styles: { fontSize: 8, halign: "center" },
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
      },
      theme: "grid",
    });

    // Save the PDF
    doc.save(
      `event_issue_product_report_${new Date().toISOString().slice(0, 10)}.pdf`,
    );
  };
  //download reciept
  const handleDownload1 = async (row, event) => {
    event.stopPropagation();

    // ✅ NEW: Prevent download if status is "Created"
    if (
      row.issue_product_status === 1 ||
      row.issue_product_description === "Created"
    ) {
      return;
    }

    // Initialize product-related values
    let saleProductsValue = "";
    let refundProductsValue = "";

    try {
      // 1. Wait for fetch before touching PDF
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/events/geteventproductbyid",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            issue_product_id: row.event_issue_product_id,
          }),
        },
      );

      const productDetails = await response.json();

      if (productDetails.length > 0) {
        productDetails.forEach((product, index) => {
          const productInfo = `${index + 1}. Product: ${product.product_name}, Quantity: ${product.quantity}`;
          const productInfoReturn = `${index + 1}. Product: ${product.product_name}, Quantity: ${product.return_quantity > 0 ? product.return_quantity : product.quantity}`;

          if (
            product.event_issue_product_status === "Issued" &&
            product.quantity > 0
          ) {
            saleProductsValue += productInfo + "\n";
          }
          if (
            product.return_quantity > 0 ||
            product.event_issue_product_status === "Returned" ||
            product.event_issue_product_status === "Partial Return"
          ) {
            refundProductsValue += productInfoReturn + "\n";
          }
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      return; // Stop if API fails
    }

    // 2. Now create PDF after data is ready
    const doc = new jsPDF();
    // Institute config
   const institute = getInstituteConfig(instituteId);

    // 2. Now create PDF after data is ready

    // Header
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, 11, {
      align: "center",
    }); // ✅
    if (institute.logo) doc.addImage(institute.logo, "PNG", 8, 1, 28, 18); // ✅

    // Address
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(institute.address1, doc.internal.pageSize.getWidth() / 2, 25, {
      align: "center",
    }); // ✅
    doc.text(institute.address2, doc.internal.pageSize.getWidth() / 2, 29, {
      align: "center",
    }); // ✅
    if (institute.tel) {
      doc.text(institute.tel, doc.internal.pageSize.getWidth() / 2, 33, {
        align: "center",
      }); // ✅
    }
    // Receipt Title
    const textStartY = 11;
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "EVENT ISSUE PRODUCT RECEIPT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" },
    ); // Center aligned title
    doc.setFontSize(10);

    const statusMap = {
      1: "Created",
      2: "Issued",
      3: "Returned",
      4: "Partial Return",
    };

    // First check if backend already gave a description
    let statusName = row.issue_product_description;

    // If not, map from status id
    if (!statusName && row.issue_product_status) {
      statusName = statusMap[row.issue_product_description] || "Unknown Status";
    }

    // Table Data
    const receiptDetails = [
      { title: "Intend ID", value: row.event_issue_product_id },
      { title: "Event Name", value: row.event_name },
      { title: "Event Category", value: row.event_category_name },
      { title: "Description", value: row.issue_description },
      { title: "Issue Date", value: row.issue_date },
      { title: "Issued By", value: row.issued_by || "" },
      { title: "Return Date", value: row.return_date },
      { title: "Status", value: statusName },
    ];

    if (saleProductsValue) {
      receiptDetails.push({
        title: "Products Issued",
        value: saleProductsValue.trim(),
      });
    }
    if (refundProductsValue) {
      receiptDetails.push({
        title: "Products Returned",
        value: refundProductsValue.trim(),
      });
    }

    // Table
    doc.autoTable({
      head: [["Particulars", ""]],
      body: receiptDetails.map((item) => {
        if (item.title === "Status") {
          return [
            { content: item.title, styles: { fontStyle: "normal" } },
            { content: item.value, styles: { fontStyle: "bold" } },
          ];
        }
        return [item.title, item.value];
      }),
      startY: receiptTextY + 15,
      styles: { fontSize: 10, cellPadding: 2 },
      headStyles: {
        fillColor: "#0A64A2",
        textColor: [255, 255, 255],
        halign: "left",
      },
      bodyStyles: { halign: "left" },
      columnStyles: { 0: { cellWidth: 70 }, 1: { cellWidth: 110 } },
      theme: "grid",
    });

    // Footer
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}/${String(currentDate.getMonth() + 1).padStart(2, "0")}/${currentDate.getFullYear()}`;
    doc.setFont("helvetica", "bold");
    doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
    doc.text("Authorized Signatory", 159, doc.previousAutoTable.finalY + 40);
    // Save
    doc.save(
      `event_issue-product-receipt_${new Date().toISOString().slice(0, 10)}.pdf`,
    );
  };

  const handleStatusChange = (event) => {
    setStatusName(event.target.value);
    let selectedStatus = saleStatus.find(
      (fr) => fr.description === event.target.value,
    );
    setStatusId(selectedStatus.issue_product_status_id);
    console.log(
      "selectedStatus.sales_status_id",
      selectedStatus.sales_status_id,
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <Layout />

      <div>
        <h1 className="sales-title">Issue Products for Event</h1>
      </div>
      {/* <br /> */}
      <div className="fees_report_box">
        <Stack spacing={4} direction="row">
          <Stack direction="row" spacing={2} alignItems="center">
            {" "}
            {/* Search Box */}
            <Box component="form" className="search-box">
              <TextField
                label="Search..."
                variant="outlined"
                fullWidth
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value);
                  setPage(0); // Reset to first page
                }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={statusName}
                  label="Grade"
                  onChange={handleStatusChange}
                >
                  {saleStatus.map((s) => (
                    <MenuItem key={s.description} value={s.description}>
                      {s.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
          <div className="download-report-box-fees-report">
            <Button
              onClick={() => handleOpenComponentCreateSale()}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "5px",
              }}
            >
              {" "}
              Issue Product{" "}
            </Button>
            <Button
              className="create-sale-btn"
              // sx={{background:'#0A64A2',padding:"7.5px"}}
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          </div>
        </Stack>
      </div>
      {/* <br /> */}

      <Box className="table-container">
        <Box className="table-container">
          <Paper className="table-container-paper">
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 750 }}
                aria-label="custom pagination table"
              >
                <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={
                        orderBy === "event_issue_product_id" ? order : false
                      }
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "event_issue_product_id"}
                        direction={
                          orderBy === "event_issue_product_id" ? order : "asc"
                        }
                        onClick={() =>
                          handleRequestSort("event_issue_product_id")
                        }
                      >
                        Indent ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "event_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "event_name"}
                        direction={orderBy === "event_name" ? order : "asc"}
                        onClick={() => handleRequestSort("event_name")}
                      >
                        Event Name
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "event_category_name"}
                        direction={
                          orderBy === "event_category_name" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("event_category_name")}
                      >
                        Event Category
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_description"}
                        direction={
                          orderBy === "issue_description" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("issue_description")}
                      >
                        Description
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_date"}
                        direction={orderBy === "issue_date" ? order : "asc"}
                        onClick={() => handleRequestSort("issue_date")}
                      >
                        Issue Date
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issued_by"}
                        direction={orderBy === "issued_by" ? order : "asc"}
                        onClick={() => handleRequestSort("issued_by")}
                      >
                        Issued By
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "return_date"}
                        direction={orderBy === "return_date" ? order : "asc"}
                        onClick={() => handleRequestSort("return_date")}
                      >
                        Return Date
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell align="center" className="sales_tablecell">
                      <TableSortLabel
                        active={orderBy === "issue_product_description"}
                        direction={
                          orderBy === "issue_product_description"
                            ? order
                            : "asc"
                        }
                        onClick={() =>
                          handleRequestSort("issue_product_description")
                        }
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Issued
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Product
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Action
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Return
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Receipt
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {paginatedRows.map((row) => (
                      <StyledTableRow
                        style={{ cursor: "pointer", textAlign: "center" }}
                        key={row.event_issue_product_id}
                        tabIndex={-1}
                        padding="none"
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                          className="table_content"
                        >
                          {row.event_issue_product_id}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.event_name}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.event_category_name}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{ p: 0, borderBottom: "none" }} // 🔹 removes the white line
                        >
                          <Tooltip
                            title={
                              row.issue_description ? row.issue_description : ""
                            }
                            placement="top"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                color: "#0A64A2",
                                p: 0.3,
                                "&:hover": { backgroundColor: "transparent" },
                              }}
                            >
                              <InfoIcon fontSize="medium" sx={{ ml: 0.5 }} />
                            </IconButton>
                          </Tooltip>
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.issue_date}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.issued_by}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.return_date}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                        >
                          {row.issue_product_description}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ padding: "0" }}
                        >
                          <Checkbox
                            checked={
                              row.issue_product_status === 2 ||
                              row.issue_product_status === 3 ||
                              row.issue_product_status === 4
                            }
                            disabled={
                              row.issue_product_status === 2 ||
                              row.issue_product_status === 3 ||
                              row.issue_product_status === 4
                            }
                            onChange={() => handleCheckboxClick(row)}
                            style={{ marginTop: "5px" }}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ padding: "0" }}
                        >
                          <ListAltIcon
                            style={{
                              marginLeft: "8px",
                              marginTop: "9px",
                              color: "#0A64A2",
                            }}
                            onClick={() => openList(row.event_issue_product_id)} // Pass the sales_id here
                          />
                          {/* New Update lastly */}
                          <Dialog
                            open={open}
                            onClose={handleClose}
                            maxWidth="lg"
                            fullWidth={false}
                            PaperProps={{
                              style: { maxHeight: "90vh", boxShadow: "0" },
                            }}
                            BackdropProps={{
                              style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
                            }}
                          >
                            <IconButton
                              onClick={handleClose}
                              style={{
                                color: "#817575",
                                position: "absolute",
                                right: "4px",
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                            <Box>
                              <DialogTitle
                                style={{
                                  color: "#0A64A2",
                                  padding: "0px 11px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "0",
                                  marginTop: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ListAltIcon
                                    style={{
                                      paddingBottom: "0",
                                      marginTop: "7px",
                                    }}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "8px",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Product List for Indent Id{" "}
                                    {selectedIssueProductId}
                                  </span>
                                </div>
                              </DialogTitle>
                            </Box>
                            <Divider
                              className="divider"
                              style={{ width: "94%", marginLeft: "13px" }}
                            />
                            <DialogContent
                              style={{
                                padding: "0",
                                margin: "0px 10px",
                                marginBottom: "10px",
                              }}
                            >
                              {(() => {
                                // Get all products for this indent
                                const allProducts = product.filter(
                                  (p) =>
                                    p.event_issue_product_id ===
                                    selectedIssueProductId,
                                );

                                if (allProducts.length === 0) {
                                  return (
                                    <p
                                      style={{
                                        margin: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      No products available.
                                    </p>
                                  );
                                }

                                // Determine the overall status from the first product (they all share same parent status)
                                const overallStatus =
                                  allProducts[0]?.event_issue_product_status ||
                                  "";

                                // Helper function to get section title and filtered products
                                const getSectionData = () => {
                                  if (overallStatus === "Created") {
                                    return {
                                      title: "",
                                      products: allProducts,
                                      showReturnQty: false,
                                    };
                                  } else if (overallStatus === "Issued") {
                                    // Check if ANY product has been partially returned
                                    const hasPartialReturns = allProducts.some(
                                      (p) => p.return_quantity > 0,
                                    );

                                    if (hasPartialReturns) {
                                      return {
                                        title: "Partially Returned Products",
                                        products: allProducts,
                                        showReturnQty: true,
                                      };
                                    } else {
                                      return {
                                        title: "Issued Products",
                                        products: allProducts,
                                        showReturnQty: false,
                                      };
                                    }
                                  } else if (
                                    overallStatus === "Partial Return"
                                  ) {
                                    return {
                                      title: "Partially Returned Products",
                                      products: allProducts,
                                      showReturnQty: true,
                                    };
                                  } else if (overallStatus === "Returned") {
                                    return {
                                      title: "Returned Products",
                                      products: allProducts,
                                      showReturnQty: true,
                                    };
                                  }

                                  return {
                                    title: "",
                                    products: allProducts,
                                    showReturnQty: false,
                                  };
                                };

                                const {
                                  title,
                                  products: filteredProducts,
                                  showReturnQty,
                                } = getSectionData();

                                return (
                                  <div style={{ marginBottom: "4px" }}>
                                    {title && (
                                      <h4
                                        style={{
                                          color: "#0A64A2",
                                          marginBottom: "0px",
                                          marginTop: "3px",
                                          marginLeft: "2px",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {title}
                                      </h4>
                                    )}
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Product Name
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            Attribute
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              color: "#0A64A2",
                                              padding: "4px",
                                            }}
                                          >
                                            {showReturnQty
                                              ? "Issued Quantity"
                                              : "Quantity"}
                                          </TableCell>
                                          {showReturnQty && (
                                            <TableCell
                                              style={{
                                                color: "#0A64A2",
                                                padding: "4px",
                                              }}
                                            >
                                              Return Quantity
                                            </TableCell>
                                          )}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {filteredProducts.map((p) => (
                                          <TableRow
                                            key={
                                              p.event_issue_product_details_id
                                            }
                                          >
                                            <TableCell
                                              align="left"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.product_name}
                                            </TableCell>
                                            <TableCell
                                              align="left"
                                              style={{ padding: "4px" }}
                                            >
                                              {p.attribute_value}
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              style={{ padding: "4px" }}
                                            >
                                              {
                                                showReturnQty
                                                  ? p.quantity +
                                                    p.return_quantity // Total originally issued
                                                  : p.quantity // Current quantity
                                              }
                                            </TableCell>
                                            {showReturnQty && (
                                              <TableCell
                                                align="center"
                                                style={{ padding: "4px" }}
                                              >
                                                {p.return_quantity || 0}
                                              </TableCell>
                                            )}
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </div>
                                );
                              })()}
                            </DialogContent>
                          </Dialog>
                        </StyledTableCell>

                        {/* action compnent icon button */}

                        <StyledTableCell
                          align="center"
                          className="table_content"
                          onClick={() => handleEditOpenComponent(row)}
                          style={{ padding: "0" }}
                        >
                          {row.issue_product_status === 1 ? (
                            <Tooltip
                              title="Edit Product"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={editProductIcon}
                                alt="Edit Product Icon"
                                style={{ height: "30px", marginBottom: "-2px" }}
                              />
                            </Tooltip>
                          ) : row.issue_product_status === 2 ||
                            row.issue_product_status === 3 ||
                            row.issue_product_status === 4 ? (
                            <Tooltip
                              title="Issue Product"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={issueProductIcon}
                                alt="Add Product Icon"
                                style={{ height: "30px", marginBottom: "-2px" }}
                              />
                            </Tooltip>
                          ) : null}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          className="table_content"
                          style={{ padding: "0" }}
                        >
                          {row.issue_product_status === 2 ||
                          row.issue_product_status === 3 ? (
                            <Tooltip
                              title="Return Product"
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "white",
                                    color: "rgb(0 0 0 / 90%)",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    boxShadow:
                                      "0px 4px 6px rgba(65, 61, 61, 0.1)",
                                    fontSize: "14px",
                                  },
                                },
                              }}
                            >
                              <img
                                src={returnProductIcon}
                                alt="Return Product Icon"
                                style={{
                                  height: "30px",
                                  marginBottom: "-2px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(row)}
                              />
                            </Tooltip>
                          ) : (
                            <img
                              src={returnProductIcon}
                              alt="Return Product Icon"
                              style={{
                                height: "30px",
                                marginBottom: "-2px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(row)}
                            />
                          )}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Button
                            variant="text"
                            onClick={(event) => handleDownload1(row, event)}
                            startIcon={<DownloadIcon />}
                            style={{ padding: "0" }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
                <TableFooter className="table-footer">
                  <TableRow className="table-header">
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className="table-pagination"
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>

      {/* issue product status pop up dilouge  */}

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {dialogType === "confirmation" ? (
            <>
              <Button
                variant="contained"
                onClick={handleDialogConfirm}
                className="no-btn"
              >
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={handleDialogClose}
                autoFocus
                className="no-btn"
              >
                No
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={handleDialogClose}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* issue product dilouge  */}

      <Dialog
        open={openIssueComponent}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div className="icon-btn">
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={issueProductIcon}
            alt="issueProductIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">Issue Product</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />

        <DialogContent>
          <EventProductIssue
            setOpenIssueComponent={setOpenIssueComponent}
            onRefresh={getSales} // Add this prop
            SelectedEventissueProductId={SelectedEventissueProductId}
            SelectedEventStatusId={SelectedEventStatusId}
            setopenEditComponent={setopenEditComponent}
          />
        </DialogContent>
      </Dialog>

      {/* action product dilouge  */}

      <Dialog
        open={openEditComponent}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div className="icon-btn">
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={editProductIcon}
            alt="editProductIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">{EditComponentName}</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />

        <DialogContent>
          {/* Replace with your CreateSale component */}
          <EventProductEdit
            setopenEditComponent={setopenEditComponent}
            EventId={EventId}
            SelectedEventissueProductId={SelectedEventissueProductId}
            SelectedEventName={SelectedEventName}
            data={data}
            EventDescription={EventDescription}
            SelectedEventStatusId={SelectedEventStatusId}
            SelectedEventCategory={SelectedEventCategory}
            SelectedEventId={SelectedEventId}
          />
        </DialogContent>
      </Dialog>

      {/* return product dilouge  */}

      <Dialog
        open={openComponentRefundSale}
        onClose={handleCloseComponent}
        maxWidth="100%"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            paddingBottom: "0",
            paddingTop: "0",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseComponent}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={returnProductIcon}
            alt="returnProductIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">Return Product</span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent>
          <EventReturnProduct
            staffId1={staffId1}
            staffName={staffName}
            setopenReturnProductComponent={setopenReturnProductComponent}
            getSales={getSales}
            selectedIssueProductId={selectedIssueProductId}
            roleName={roleName}
            SelectedEventName={SelectedEventName}
            SelectedEventCategory={SelectedEventCategory} // Make sure this is included
            SelectedEventissueProductId={SelectedEventissueProductId}
            EventProduct={product}
            setOpenComponentRefundSale={setOpenComponentRefundSale}
            getProduct={getProduct}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog Popup */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessageForReturn}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setOpenDialog(false)}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
